import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FileUploaderInterface } from './file-uploader.interface';
import { Observable } from 'rxjs';
import { FileUploadService } from './file-upload.service';
import { FileUploadInfo } from './file-upload-info';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'forms-file-upload-field',
  styleUrls: ['./file-upload-field.component.scss'],
  template: `
    <ng-container *ngIf="!isUploaded">
      <mat-form-field class="file-upload" [ngClass]="{ invalid: formController?.invalid && formController?.touched }">
        <mat-icon matPrefix class="pointer" (click)="fileInput.click()" *ngIf="!isUploading">attach_file</mat-icon>
        <mat-icon matPrefix *ngIf="isUploading">attach_file</mat-icon>
        <input
          matInput
          class="file-input pointer"
          [placeholder]="label"
          (click)="fileInput.click()"
          *ngIf="!isUploading"
          readonly
        />
        <input matInput class="file-input" [placeholder]="'Uploading...'" *ngIf="isUploading" readonly />
        <mat-spinner [diameter]="30" [strokeWidth]="4" *ngIf="isUploading" mode="indeterminate"></mat-spinner>
      </mat-form-field>
      <input
        #fileInput
        type="file"
        (change)="handleInputChange()"
        [accept]="formatFileTypes"
        class="hide-default-input"
        [disabled]="disabled"
      />
    </ng-container>
    <ng-container *ngIf="isUploaded">
      <mat-form-field class="file-uploaded">
        <mat-icon matPrefix>attach_file</mat-icon>
        <a href="{{ fileUrl }}" target="_blank" [attr.download]="enableDownload ? '' : undefined">
          <input matInput class="file-input-uploaded" [placeholder]="label" [value]="fileName" [disabled]="true" />
        </a>
        <mat-icon *ngIf="!disabled" matSuffix class="remove-file-icon" (click)="removeFile.emit(index)">
          cancel
        </mat-icon>
      </mat-form-field>
    </ng-container>
  `,
})
export class FileUploadFieldComponent {
  @Input() label: string;
  @Input() uploadUrl: string;
  @Input() customUploader: FileUploaderInterface;
  @Input() isUploaded = false;
  @Input() index: number;
  @Input() fileName: string;
  @Input() fileUrl: string;
  @Input() formController: UntypedFormControl;
  @Input() fileTypes: string[];
  @Input() disabled: boolean;
  @Input() enableDownload = true;
  @Output() fileUploaded = new EventEmitter<FileUploadInfo>();
  @Output() fileUploadError = new EventEmitter<Error>();
  @Output() removeFile = new EventEmitter<number>();
  @ViewChild('fileInput') fileInput: ElementRef;

  isUploading = false;

  constructor(private fileUploadService: FileUploadService) {}

  get formatFileTypes(): string {
    if (this.fileTypes && this.fileTypes.length > 0) {
      return this.fileTypes.join(',');
    } else {
      return '';
    }
  }

  handleInputChange(): void {
    if (this.fileInput.nativeElement.files.length > 0 && this.fileInput.nativeElement.files[0]) {
      const file = this.fileInput.nativeElement.files[0];
      this.isUploading = true;
      let call: Observable<FileUploadInfo>;
      if (this.customUploader) {
        call = this.customUploader.uploadFile(file);
      } else {
        call = this.fileUploadService.upload(this.uploadUrl, file);
      }

      call.subscribe(
        (fileUpload) => {
          this.isUploading = false;
          // Ensure protocol is attached to url.
          fileUpload.url = this.prependProtocol(fileUpload.url);
          this.fileUploaded.emit(fileUpload);
        },
        (err) => {
          this.isUploading = false;
          this.fileUploadError.emit(err);
        },
      );
    }
  }

  prependProtocol(url: string): string {
    if (!url.startsWith('http')) {
      let prependString = 'https:';
      if (!url.startsWith('//')) {
        prependString += '//';
      }
      return prependString + url;
    }
    return url;
  }
}
